import type { Page } from '../../types';

const approvalQ2: Page[] = [
  {
    pageType: 'question',
    title: 'Approval',
    name: 'approval-q2',
    hidePageTitle: true,
    disabled: [
      {
        field: 'pending_approval_quarter',
        condition: 'notEquals',
        value: 'Q2',
      },
    ],
    questions: [
      {
        questionType: 'reportPeriod',
        title: 'Period of Report',
        name: 'approval-report-period-q2',
        readOnly: true,
        autoFill: {
          keys: [],
          field: 'report-period',
        },
      },
      {
        questionType: 'textarea',
        title: 'Your assessment of performance',
        hint: 'Taking into account the summary the individual has submitted, along with any feedback received, please provide your assessment of their performance. Please provide a clear, concise summary, which directly relates to the minimum standards and business objectives. In making this mid-year assessment, it is important to acknowledge and set aside any personal bias, conscious and unconscious, to ensure an objective appraisal of the person you are reporting on',
        name: 'talent-career-managers-assessment-q2',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'select',
        title: 'Indicative Mid-Year Performance Marking',
        name: 'talent-career-indicative-performance-q2',
        hint: 'Please confirm the indicative performance rating you are putting forward for the individual.  Markings should not be communicated to individuals until formal sign-off has been completed and communicated.',
        hintOption: 'Select an option',
        options: ['Exceeding','High Performing','Achieving','Partially Met'], 
        rules: {
          required: true,
        },
      },
      {
        questionType: 'select',
        title: 'Indicative Mid-Year Talent Position',
        name: 'talent-career-manager-9-box-grid-q2',
        hint: 'Please confirm the indicative talent position you are putting forward for the individual',
        detailsHeading: 'Learn more about the 9 Box Grid, including the box defenitions',
        detailsContent:
          'To learn more, please visit: <a href="https://intranet.cabinetoffice.gov.uk/information-for-employees/pay-and-reward/scs-pay-and-reward/scs-career-development-conversations/" target="_blank" rel="noopener noreferrer">intranet guidance</a>.',
        hintOption: 'Select an option',
        options: [
          '1 Star',
          '2 Excellent',
          '3 High Potential',
          '4 Strong',
          '5 Good',
          '6 Expert',
          '7 Early Promise',
          '8 Effective',
          '9 Inconsistent',
        ],
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default approvalQ2;
